<nav [ngClass]="{
      'navigation-shape bg-transparent h-navigation select-none': true,
      }">
  <ul class="grid grid-cols-3 size-full items-stretch">
    <li class="text-white flex flex-grow justify-center self-center pl-2 sm:pr-5">
      <a [routerLink]="['/']" [routerLinkActive]="'text-primary'" [routerLinkActiveOptions]="{exact: true}" class="flex self-end gap-y-1 flex-col justify-center items-center">
        <ng-icon name="heroHome" size="1.9rem" strokeWidth="1"></ng-icon>
        <span class="text-xs">Home</span>
      </a>
    </li>
    <li class="flex h-full relative justify-center">
      <a [routerLink]="['/kaart']" class="flex flex-col h-full relative justify-center">
        <span data-map-icon-holder
          class="text-secondary map-button absolute left-1/2 transform -translate-x-1/2 size-navigation-circle-button rounded-full bg-primary flex justify-center items-center">
          <span class="relative">
            <ng-icon class="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2" name="heroMap" size="2.5rem" strokeWidth="1"></ng-icon>
            <ng-icon class="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2" name="heroMapPinSolid" size="0.70rem" strokeWidth="0.5"></ng-icon>
          </span>
        </span>
        <span [ngClass]="isMap ? 'text-primary' : 'text-white'" class="self-end text-xs" style="margin-top: calc(4rem - 30.05px)">Kaart</span>
      </a>
    </li>
    <li class="bg-secondary-600 text-white flex h-full flex-grow justify-center self-center pr-2 sm:pr-5">
      <button type="button" (click)="openMenu()" class="flex self-center gap-y-1 flex-col justify-center items-center">
        <ng-icon name="heroBars3" size="1.9rem" strokeWidth="0.8"></ng-icon>
        <span class="text-xs">Menu</span>
      </button>
    </li>
  </ul>
</nav>
